import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-pending-feedback',
  templateUrl: './pending-feedback.component.html',
  styleUrls: ['./pending-feedback.component.scss']
})
export class PendingFeedbackComponent implements OnInit {

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public _data: any,
    public _bottomSheetRef: MatBottomSheetRef<PendingFeedbackComponent>
  ) {

  }


  ngOnInit(): void {
  }

}
